import React from 'react';
import { IoTicketOutline } from '@react-icons/all-files/io5/IoTicketOutline';

import { decorateComponent } from '../../documentComponents';
import { Coupon } from './Coupon';
import { CouponInspector } from './Coupon.inspector';

export default decorateComponent(Coupon, 'block', {
  id: 'coupon',
  label: '쿠폰',
  defaultProps: {
    children: [],
  },
  allowedChildren: [],
  disallowedAncestors: [
    'a',
    'tabButton',
    'video',
    'accordionButton',
  ],
  renderIcon: () => <IoTicketOutline />,
  renderInspector: CouponInspector,
});
